import { render } from "./popup-recharge.vue?vue&type=template&id=96af132e&scoped=true&ts=true"
import script from "./popup-recharge.vue?vue&type=script&lang=ts"
export * from "./popup-recharge.vue?vue&type=script&lang=ts"

import "./popup-recharge.vue?vue&type=style&index=0&id=96af132e&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96af132e"]])

export default __exports__